import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetParticipantQueryResponse, GetParticipantQueryParams, GetParticipant400, GetParticipant401, GetParticipant403, GetParticipant422, GetParticipant429, GetParticipant500 } from "../types/GetParticipant";

export const getParticipantQueryKey = (params: GetParticipantQueryParams) =>     [{url:`/api/purchase-tenders/v1/show_participant`},...(params ? [params] : [])] as const;
      export function getParticipantQueryOptions <TData = GetParticipantQueryResponse, TError = GetParticipant400 | GetParticipant401 | GetParticipant403 | GetParticipant422 | GetParticipant429 | GetParticipant500>(params: GetParticipantQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getParticipantQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v1/show_participant`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v1/show_participant
 */

export function useGetParticipant <TData = GetParticipantQueryResponse, TError = GetParticipant400 | GetParticipant401 | GetParticipant403 | GetParticipant422 | GetParticipant429 | GetParticipant500>(params: GetParticipantQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getParticipantQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getParticipantQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
